@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.container {
  font-size: 26px;
  color: @no-permission-page--text-color;
  background-color: @no-permission-page--background-color;
  width: 100%;
  text-align: center;
  height: 100%;
}
.icon {
  > svg {
    transform: scale(0.5);
    height: 130px;
    width: 130px;
    fill: @no-permission-page--fill-color;
  }
}
.message {
  line-height: 30px;
}
